import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT, DtoType } from '@core/data/dto/dto-types';
import { DtoImport, DtoExport } from '@core/utils/dto';
import { DeliveryOrderLocationSchema } from './delivery-order-location.schema';

export class DeliveryOrderLocation {
    public id: string;
    public lat: number;
    public lng: number;
    public latitude: number;
    public longitude: number;
    public name: string;

    @DtoImport(DeliveryOrderLocationSchema)
    static import(dto: Dto): any {}

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderLocationSchema,
        },
    ])
    export(type?: DtoType): any {}
}
